export default __webpack_public_path__ + "media/images/coworkr/logo-with-favicon-5dcd3b7a2524381f9a942074d62496fb.png";